export const validateSearch = (value, searchTag) => {
    if (searchTag === 'document') {
        if (value.length < 4 ) {
            return false;
        }
    } else {
        const regex = /^[A-Z]\d{6}\/\d{3}$/;
        return regex.test(value);
    }
    return true;
};
